import { useI18n } from "@/context/I18nContext";
import { Globe } from "lucide-react";

// Compact PL/EN/VI segmented toggle. variant: 'default' | 'subtle'
export function LangToggle({ className = "", showIcon = false }) {
  const { lang, setLang } = useI18n();
  const btn = (code) => {
    const active = lang === code;
    return (
      <button
        type="button"
        data-testid={`lang-toggle-${code}`}
        onClick={() => setLang(code)}
        aria-pressed={active}
        aria-label={LANG_NAMES[code]}
        title={LANG_NAMES[code]}
        className={`px-2.5 py-1 text-xs font-medium rounded-md transition-colors duration-150 ${
          active ? "bg-cyan-400/15 text-cyan-200" : "text-muted-foreground hover:text-foreground"
        }`}
      >
        {code.toUpperCase()}
      </button>
    );
  };
  return (
    <div className={`inline-flex items-center gap-1 rounded-lg border border-white/10 bg-white/5 p-0.5 ${className}`} data-testid="lang-toggle">
      {showIcon && <Globe className="text-muted-foreground ml-1" style={{ width: 14, height: 14 }} />}
      {btn("pl")}
      {btn("en")}
      {btn("vi")}
    </div>
  );
}

const LANG_NAMES = { pl: "Polski", en: "English", vi: "Tiếng Việt" };
